import { useTranslation } from "@/i18n/client";
import { InputTooltip } from "@/components/InputTooltip";
import Input from "@/components/Input";
import { Trans } from "react-i18next";
import { InputProps } from "@/components/Input";

export const FVENumber = (props: InputProps) => {
  const { t } = useTranslation("supplyPoint");
  const { t: tHints } = useTranslation("hints");

  return (
    <InputTooltip
      tooltipProps={{
        label: <Trans i18nKey="supplyPoint.bundleServicesFVENumber" t={tHints} />,
      }}>
      <Input {...props} label={t("fveData.fveNumber")} />
    </InputTooltip>
  );
};
